var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"pagination"},_vm._l((_vm.btnCount),function(btn){return _c('li',{staticClass:"page-item"},[_c('a',{class:['page-link', {'active': parseInt(_vm.currentPage) === btn}],attrs:{"href":"javascript:void(0);"},on:{"click":function($event){_vm.changePage(btn)}}},[_vm._v(_vm._s(btn))])])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-698e671a","hasScoped":true,"buble":{"transforms":{}}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pagination.vue
// module id = 1112
// module chunks = 1